import { atom, createStore } from "jotai";
import { User } from "@/types";

/**
 * Store
 */
function createGlobalStore(initialUser: User | null) {
  const store = createStore();
  store.set(userAtom, initialUser);
  return store;
}

const userAtom = atom<User | null>(null);

export { createGlobalStore, userAtom };
